






















import { Vue, Component } from 'vue-property-decorator';
import { Prop } from 'vue-property-decorator';

import UnorderedList from '@/components/Atoms/List/UnorderedList.vue';
import ListItem from '@/components/Atoms/ListItem/ListItem.vue';
import RadioButton from '@/components/Atoms/Input/RadioButton.vue';
import Price from '@/components/Atoms/Text/Price.vue';

import { StaticIp } from '@/data/hikari/staticIp';

type IpOption = { id: string; name: string; monthlyCharge: number | null };

@Component({
  components: {
    UnorderedList,
    ListItem,
    RadioButton,
    Price,
  },
})
export default class StaticIpComponent extends Vue {
  @Prop() StaticIpList!: StaticIp[];

  mounted() {
    // デフォルトで申し込まないを選択する
    const initialValue = this.$store.getters['hikari/staticIp'];
    if (initialValue === '') {
      this.$store.commit('hikari/staticIp', 'none');
    }
  }

  get options(): IpOption[] {
    let list: IpOption[] = [
      { id: 'none', name: '申し込まない', monthlyCharge: null },
    ];
    this.StaticIpList.reduce((array, value) => {
      array.push({
        id: value.id,
        name: value.name,
        monthlyCharge: value.monthlyCharge,
      });
      return array;
    }, list);
    return list;
  }
}
